import * as React from 'react';

const SkipContent = () => {
  const handleScrollComplete = (element) => {
    const focusableElements = element.querySelectorAll(
      'a, button, input, select, textarea'
    );

    const nextElement = element?.nextElementSibling;

    const moveToNextElement = () => {
      if (nextElement) {
        handleScrollComplete(nextElement);
      } else {
        return;
      }
    };

    if (focusableElements) {
      for (const focusableElement of focusableElements) {
        if (focusableElement.offsetParent !== null) {
          focusableElement.focus({ preventScroll: true });
          return;
        } else {
          moveToNextElement();
        }
      }
    } else {
      moveToNextElement();
    }
  };

  const handleClick = () => {
    const firstElement = document.querySelector('header')?.nextElementSibling;
    firstElement.scrollIntoView({ behavior: 'smooth' });
    setTimeout(() => {
      handleScrollComplete(firstElement);
    }, 500);
  };

  return (
    <div className="skip-content__wrapper">
      <button
        className="skip-content__button"
        tabIndex="0"
        onClick={handleClick}
      >
        Skip to main content
      </button>
    </div>
  );
};

export default SkipContent;
